import { Button as ChakraButton, ButtonProps as ChakraButtonProps } from '@chakra-ui/react';

export function Button(props: ChakraButtonProps) {
  return (
    <ChakraButton
      borderRadius={props.borderRadius || '8px'}
      _loading={{
        display: 'flex',
        justifyItems: 'center',
        backgroundColor: props.backgroundColor || props.bg,
        _hover: {
          backgroundColor: props.backgroundColor || props.bg,
        },
      }}
      _hover={{
        backgroundColor: props.backgroundColor || props.bg,
      }}
      _focus={{
        boxShadow: 0,
      }}
      _active={{
        backgroundColor: props.backgroundColor || props.bg,
      }}
      letterSpacing={'0.5px'}
      {...props}
    />
  );
}
